var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32449,
    height: 5109,
    viewBox: "0 0 32449 5109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M360.578 0.335938V170.242",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.273 94.4072L153.638 107.301L206.425 76.6764L183.255 63.7822L131.273 94.4072Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.273 162.504L153.638 175.399L206.425 144.776L183.255 131.882L131.273 162.504Z",
    stroke: "#231F20",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 162.504L153.765 175.399L206.55 144.776L183.382 131.882L131.4 162.504Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.639 107.302V175.399",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.053 63.7822V131.882L206.401 144.752V76.6547",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.273 94.1831V162.28",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.273 130.997L153.638 143.891L206.425 113.266L183.255 100.372L131.273 130.997Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 162.504L153.765 175.399L206.55 144.776L183.382 131.882L131.4 162.504Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.639 143.891V175.401",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.273 130.773V163.098",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.354 143.93L175.718 156.824L228.506 126.199L205.335 113.305L153.354 143.93Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.482 175.437L175.847 188.331L228.632 157.709L205.464 144.814L153.482 175.437Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.719 156.824V188.331",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228.078 125.912V157.42",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.354 143.706V176.031",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.948 93.7993L82.5861 106.696L29.7988 76.071L52.9689 63.1768L104.948 93.7993Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.948 161.899L82.5861 174.793L29.7988 144.168L52.9689 131.274L104.948 161.899Z",
    stroke: "#231F20",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.822 161.899L82.4572 174.793L29.6699 144.168L52.84 131.274L104.822 161.899Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5859 106.696V174.794",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1688 63.1768V131.274L29.8203 144.147V76.0493",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.947 93.5776V161.675",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1 94.0913L23.3648 106.986L76.152 76.3605L52.982 63.4663L1 94.0913Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1 162.189L23.3648 175.085L76.152 144.46L52.982 131.566L1 162.189Z",
    stroke: "#231F20",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12891 162.189L23.4937 175.085L76.2785 144.46L53.1109 131.566L1.12891 162.189Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3652 106.985V175.085",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7793 63.4663V131.566L76.1278 144.439V76.3388",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1 93.8672V161.967",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.002 0.461426V170.242",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M284.875 0.335938V170.242",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M304.432 1.27637V170.242",
    stroke: "white",
    strokeWidth: 0.501496,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M322.727 0.461426V170.242",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.281 0.461426V170.242",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M265.185 155.291C268.252 155.291 270.738 152.805 270.738 149.738C270.738 146.672 268.252 144.186 265.185 144.186C262.119 144.186 259.633 146.672 259.633 149.738C259.633 152.805 262.119 155.291 265.185 155.291Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M284.744 135.419C287.811 135.419 290.297 132.933 290.297 129.866C290.297 126.799 287.811 124.313 284.744 124.313C281.677 124.313 279.191 126.799 279.191 129.866C279.191 132.933 281.677 135.419 284.744 135.419Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M304.301 81.7952C307.367 81.7952 309.853 79.3092 309.853 76.2426C309.853 73.1759 307.367 70.6899 304.301 70.6899C301.234 70.6899 298.748 73.1759 298.748 76.2426C298.748 79.3092 301.234 81.7952 304.301 81.7952Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M342.152 102.612C345.219 102.612 347.705 100.126 347.705 97.0595C347.705 93.9928 345.219 91.5068 342.152 91.5068C339.086 91.5068 336.6 93.9928 336.6 97.0595C336.6 100.126 339.086 102.612 342.152 102.612Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M322.279 93.1506C325.346 93.1506 327.832 90.6647 327.832 87.598C327.832 84.5314 325.346 82.0454 322.279 82.0454C319.213 82.0454 316.727 84.5314 316.727 87.598C316.727 90.6647 319.213 93.1506 322.279 93.1506Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M360.447 130.054C363.514 130.054 366 127.568 366 124.502C366 121.435 363.514 118.949 360.447 118.949C357.381 118.949 354.895 121.435 354.895 124.502C354.895 127.568 357.381 130.054 360.447 130.054Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M265.188 149.738L284.743 129.866L304.302 76.2422L342.309 98.6383L360.448 124.502",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M265.188 98.6386L284.743 78.7644L303.827 52.1104L342.309 64.4139L360.448 73.4022",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.45 1.45"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M265.185 104.191C268.252 104.191 270.738 101.705 270.738 98.6386C270.738 95.5719 268.252 93.0859 265.185 93.0859C262.119 93.0859 259.633 95.5719 259.633 98.6386C259.633 101.705 262.119 104.191 265.185 104.191Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.744 84.3172C287.811 84.3172 290.297 81.8312 290.297 78.7645C290.297 75.6979 287.811 73.2119 284.744 73.2119C281.677 73.2119 279.191 75.6979 279.191 78.7645C279.191 81.8312 281.677 84.3172 284.744 84.3172Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M303.826 57.6633C306.893 57.6633 309.379 55.1774 309.379 52.1107C309.379 49.0441 306.893 46.5581 303.826 46.5581C300.759 46.5581 298.273 49.0441 298.273 52.1107C298.273 55.1774 300.759 57.6633 303.826 57.6633Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M342.308 69.9666C345.375 69.9666 347.861 67.4806 347.861 64.4139C347.861 61.3473 345.375 58.8613 342.308 58.8613C339.242 58.8613 336.756 61.3473 336.756 64.4139C336.756 67.4806 339.242 69.9666 342.308 69.9666Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M322.123 64.2883C325.19 64.2883 327.676 61.8024 327.676 58.7357C327.676 55.6691 325.19 53.1831 322.123 53.1831C319.056 53.1831 316.57 55.6691 316.57 58.7357C316.57 61.8024 319.056 64.2883 322.123 64.2883Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M360.447 78.9548C363.514 78.9548 366 76.4689 366 73.4022C366 70.3356 363.514 67.8496 360.447 67.8496C357.381 67.8496 354.895 70.3356 354.895 73.4022C354.895 76.4689 357.381 78.9548 360.447 78.9548Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32213.3 5014.07L32235.6 5026.97L32288.4 4996.34L32265.3 4983.45L32213.3 5014.07Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M32213.3 5082.17L32235.6 5095.06L32288.4 5064.44L32265.3 5051.55L32213.3 5082.17Z",
    stroke: "#231F20",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32213.4 5082.17L32235.8 5095.06L32288.6 5064.44L32265.4 5051.55L32213.4 5082.17Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32235.6 5026.97V5095.06",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32265.1 4983.45V5051.55L32288.4 5064.42V4996.32",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M32213.3 5013.85V5081.94",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M32213.3 5050.66L32235.6 5063.56L32288.4 5032.93L32265.3 5020.04L32213.3 5050.66Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32213.4 5082.17L32235.8 5095.06L32288.6 5064.44L32265.4 5051.55L32213.4 5082.17Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32235.6 5063.56V5095.07",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32213.3 5050.44V5082.76",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32235.4 5063.59L32257.7 5076.49L32310.5 5045.86L32287.3 5032.97L32235.4 5063.59Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32235.5 5095.1L32257.8 5108L32310.6 5077.37L32287.5 5064.48L32235.5 5095.1Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32257.7 5076.49V5108",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M32310.1 5045.58V5077.08",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M32235.4 5063.37V5095.69",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M32187 5013.46L32164.6 5026.36L32111.8 4995.74L32135 4982.84L32187 5013.46Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M32187 5081.56L32164.6 5094.46L32111.8 5063.83L32135 5050.94L32187 5081.56Z",
    stroke: "#231F20",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M32186.8 5081.56L32164.5 5094.46L32111.7 5063.83L32134.8 5050.94L32186.8 5081.56Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M32164.6 5026.36V5094.46",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M32135.2 4982.84V5050.94L32111.8 5063.81V4995.71",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M32186.9 5013.24V5081.34",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.75 1.75"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M32083 5013.76L32105.4 5026.65L32158.2 4996.02L32135 4983.13L32083 5013.76Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M32083 5081.85L32105.4 5094.75L32158.2 5064.12L32135 5051.23L32083 5081.85Z",
    stroke: "#231F20",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32083.1 5081.85L32105.5 5094.75L32158.3 5064.12L32135.1 5051.23L32083.1 5081.85Z",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M32105.4 5026.65V5094.75",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M32134.8 4983.13V5051.23L32158.1 5064.1V4996",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M32083 5013.53V5081.63",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32347 4920.13V5089.91",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32366.9 4920V5089.91",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32386.4 4920.94V5089.91",
    stroke: "white",
    strokeWidth: 0.501496,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32404.7 4920.13V5089.91",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32424.3 4920.13V5089.91",
    stroke: "white",
    strokeWidth: 0.503907,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M32347.2 5074.95C32350.3 5074.95 32352.7 5072.47 32352.7 5069.4C32352.7 5066.34 32350.3 5063.85 32347.2 5063.85C32344.1 5063.85 32341.6 5066.34 32341.6 5069.4C32341.6 5072.47 32344.1 5074.95 32347.2 5074.95Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M32366.7 5055.08C32369.8 5055.08 32372.3 5052.6 32372.3 5049.53C32372.3 5046.46 32369.8 5043.98 32366.7 5043.98C32363.7 5043.98 32361.2 5046.46 32361.2 5049.53C32361.2 5052.6 32363.7 5055.08 32366.7 5055.08Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M32386.3 5001.46C32389.4 5001.46 32391.9 4998.97 32391.9 4995.91C32391.9 4992.84 32389.4 4990.35 32386.3 4990.35C32383.2 4990.35 32380.8 4992.84 32380.8 4995.91C32380.8 4998.97 32383.2 5001.46 32386.3 5001.46Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M32424.2 5022.28C32427.2 5022.28 32429.7 5019.79 32429.7 5016.72C32429.7 5013.66 32427.2 5011.17 32424.2 5011.17C32421.1 5011.17 32418.6 5013.66 32418.6 5016.72C32418.6 5019.79 32421.1 5022.28 32424.2 5022.28Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M32404.3 5012.81C32407.3 5012.81 32409.8 5010.33 32409.8 5007.26C32409.8 5004.2 32407.3 5001.71 32404.3 5001.71C32401.2 5001.71 32398.7 5004.2 32398.7 5007.26C32398.7 5010.33 32401.2 5012.81 32404.3 5012.81Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M32442.4 5049.72C32445.5 5049.72 32448 5047.23 32448 5044.17C32448 5041.1 32445.5 5038.61 32442.4 5038.61C32439.4 5038.61 32436.9 5041.1 32436.9 5044.17C32436.9 5047.23 32439.4 5049.72 32442.4 5049.72Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M32347.2 5069.4L32366.7 5049.53L32386.3 4995.91L32424.3 5018.3L32442.4 5044.17",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M32347.2 5018.3L32366.7 4998.43L32385.8 4971.77L32424.3 4984.08L32442.4 4993.07",
    stroke: "white",
    strokeWidth: 0.631692,
    strokeMiterlimit: 10,
    strokeDasharray: "1.45 1.45"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M32347.2 5023.86C32350.3 5023.86 32352.7 5021.37 32352.7 5018.3C32352.7 5015.24 32350.3 5012.75 32347.2 5012.75C32344.1 5012.75 32341.6 5015.24 32341.6 5018.3C32341.6 5021.37 32344.1 5023.86 32347.2 5023.86Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M32366.7 5003.98C32369.8 5003.98 32372.3 5001.5 32372.3 4998.43C32372.3 4995.36 32369.8 4992.88 32366.7 4992.88C32363.7 4992.88 32361.2 4995.36 32361.2 4998.43C32361.2 5001.5 32363.7 5003.98 32366.7 5003.98Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M32385.8 4977.33C32388.9 4977.33 32391.4 4974.84 32391.4 4971.77C32391.4 4968.71 32388.9 4966.22 32385.8 4966.22C32382.8 4966.22 32380.3 4968.71 32380.3 4971.77C32380.3 4974.84 32382.8 4977.33 32385.8 4977.33Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M32424.3 4989.63C32427.4 4989.63 32429.9 4987.14 32429.9 4984.08C32429.9 4981.01 32427.4 4978.53 32424.3 4978.53C32421.2 4978.53 32418.8 4981.01 32418.8 4984.08C32418.8 4987.14 32421.2 4989.63 32424.3 4989.63Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M32404.1 4983.95C32407.2 4983.95 32409.7 4981.47 32409.7 4978.4C32409.7 4975.33 32407.2 4972.85 32404.1 4972.85C32401.1 4972.85 32398.6 4975.33 32398.6 4978.4C32398.6 4981.47 32401.1 4983.95 32404.1 4983.95Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M32442.4 4998.62C32445.5 4998.62 32448 4996.13 32448 4993.07C32448 4990 32445.5 4987.51 32442.4 4987.51C32439.4 4987.51 32436.9 4990 32436.9 4993.07C32436.9 4996.13 32439.4 4998.62 32442.4 4998.62Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.315846,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.45c13682c04a7e3b6c83258609287d83.svg";
export { ForwardRef as ReactComponent };